import { strategyToOptions } from "@/common/utils/strategyToOptions"
import { CompanyData } from "@/features/companies/types/companies.type";

export const equipmentDriverLicenseRequirementsForConsumption: Record<CompanyData['equipment_driver_license_requirements_for_consumptions'], string> = {
  none: 'Não',
  validate_buyer_has_matching_license: 'Sim',
}

export const equipmentDriverLicenseRequirementsForConsumptionOptions = strategyToOptions(equipmentDriverLicenseRequirementsForConsumption);
